export const ASSET_COLOR_1 = '#888888'
export const ASSET_COLOR_2 = '#444444'